import { render, staticRenderFns } from "./Ramucirumab.vue?vue&type=template&id=a26f57a4&scoped=true"
import script from "./Ramucirumab.vue?vue&type=script&lang=js"
export * from "./Ramucirumab.vue?vue&type=script&lang=js"
import style0 from "./Ramucirumab.vue?vue&type=style&index=0&id=a26f57a4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a26f57a4",
  null
  
)

export default component.exports